/**
 * reachPaywall — Substack paywall divider.
 *
 * Renders in-editor as a horizontal rule with a "Paid content below"
 * label. Substack serializer replaces it with `<!--paywall-->` (Substack's
 * paywall marker comment). Other platforms (LinkedIn / IG / X) have no
 * paywall concept — their serializers TRUNCATE the body at this node so
 * only the public preview ships.
 *
 * HTML on the wire: <div data-reach-paywall="1"></div>.
 */
import { Node, mergeAttributes } from '@tiptap/core';

export const ReachPaywall = Node.create({
    name: 'reachPaywall',

    group: 'block',
    atom: true,
    selectable: true,
    draggable: false,

    parseHTML() {
        return [
            { tag: 'div[data-reach-paywall]' },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes(HTMLAttributes, {
                'data-reach-paywall': '1',
                class: 'adm-editor__block-paywall',
            }),
            ['span', { class: 'adm-editor__block-label' }, 'Paid content below this line'],
            ['span', { class: 'adm-editor__block-hint' }, 'Substack paywall · other platforms truncate here'],
        ];
    },

    addCommands() {
        return {
            insertReachPaywall: () => ({ commands }) => commands.insertContent({ type: this.name }),
        };
    },
});
